import { useQueryParams } from './useQueryParams';

const useEngageCurrentStep = () => {
    const { step } = useQueryParams<{ step: string }>();
    return parseInt(step ?? '1');
};

export { useEngageCurrentStep };
